import { render, staticRenderFns } from "./PaymentScreen.vue?vue&type=template&id=2ade6869&scoped=true&"
import script from "./PaymentScreen.vue?vue&type=script&lang=js&"
export * from "./PaymentScreen.vue?vue&type=script&lang=js&"
import style0 from "./PaymentScreen.vue?vue&type=style&index=0&id=2ade6869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade6869",
  null
  
)

export default component.exports